import { Injectable, inject } from '@angular/core';
import {
  GetOnCallGridFilterModelReq,
  OnCallGridPanelForm,
} from '@pages/on-call-page/interfaces';
import { FilterCondition, OnCallStatus } from '@pages/on-call-page/constants';
import { FilterModelWithKeys } from '@features/vt-grid/interfaces/grid-context';
import { RestApiService } from '@core/services/rest-api.service';
import { Observable, take } from 'rxjs';
import { Entity } from '@shared/constants/entity';

@Injectable({ providedIn: 'root' })
export class OnCallGridPanelService {
  private api = inject(RestApiService);

  buildGetOnCallFilterModel(
    data: OnCallGridPanelForm
  ): GetOnCallGridFilterModelReq {
    const payload: GetOnCallGridFilterModelReq =
      {} as GetOnCallGridFilterModelReq;
    if (data.ShowOnlyStandby) {
      payload.OnCallStatus = OnCallStatus.OnCall;
    } else {
      payload.OnCallStatus = undefined;
    }

    if (data.Department) {
      payload.Department = data.Department.map(id => ({
        DepartmentID: id,
      }));
    }

    if (data.User) {
      payload.User = data.User.map(id => ({
        UserID: id,
      }));
    }
    if (data.Location) {
      payload.Location = data.Location.map(id => ({
        Description: id,
      }));
    }

    if (data.UserTag?.length) {
      payload.UserTag = {
        values: data.UserTag,
        operator: data.UserCondition || FilterCondition.And,
      };
    }

    if (data.VehicleTag?.length) {
      payload.VehicleTag = {
        values: data.VehicleTag,
        operator: data.VehicleCondition || FilterCondition.And,
      };
    }
    return payload;
  }

  getFilterModel(
    payload: GetOnCallGridFilterModelReq
  ): Observable<FilterModelWithKeys> {
    return this.api
      .postCustom<FilterModelWithKeys>(
        `${Entity.OnCall}/getoncallfiltermodel`,
        payload
      )
      .pipe(take(1));
  }
}
